import { TEMPLATES_API } from "../../../../constants/Configs"
import { API_REQUEST } from "../../../../constants/General"
import { Actions } from "../../../../redux/actions"
import API from "../../../../services/api"
import { getPageSize } from "../../../../services/middleware"
import { dispatch } from "../../../../utils/store"
import { handleError, handleSuccess } from "../../../../utils/toast"
import { templatesListDTO } from "../dtos/templates"

export const getTemplates = (search, sortBy, orderBy, page = 1) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  const params = {
    ...(!!search ? { search } : {}),
    ...(!!sortBy ? { sortBy } : {}),
    ...(!!orderBy ? { orderBy } : {}),
    ...(!!page ? { page, 'size': getPageSize() } : {}),
  }

  API(API_REQUEST.get, TEMPLATES_API, { params })
    .then(res => {
      dispatch(Actions.RestaurantAdminTemplates.SetTemplates, templatesListDTO(res?.data?.data?.rows))
      dispatch(Actions.RestaurantAdminTemplates.SetTotalCount, res.data.data.count)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const addTemplate = (data, search, activeSort, sortOrder, page, handleCloseAddModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.post, TEMPLATES_API, data)
    .then((res) => {
      handleSuccess(res)
      handleCloseAddModal()
      getTemplates(search, activeSort, sortOrder, page)
    })
    .catch((error) => {
      handleError(error);
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const addQuickTemplate = (data) => {
  return new Promise((resolve, reject) => {
    dispatch(Actions.RestaurantAdmin.SetLoading, true)
    API(API_REQUEST.post, TEMPLATES_API, data)
      .then((res) => {
        resolve(res);
        dispatch(Actions.RestaurantAdmin.SetLoading, false)
      })
      .catch((error) => {        
        reject(error);
        dispatch(Actions.RestaurantAdmin.SetLoading, false)
      })
  })
}


export const editTemplate = (id, data, search, activeSort, sortOrder, page, handleCloseEditModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.put, `${TEMPLATES_API}/${id}`, data)
    .then(res => {
      handleSuccess(res)
      handleCloseEditModal()
      getTemplates(search, activeSort, sortOrder, page)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const deleteTemplate = (id, search, activeSort, sortOrder, page, handleCloseDeleteModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.delete, `${TEMPLATES_API}/${id}`)
    .then(res => {
      handleSuccess(res)
      handleCloseDeleteModal(false)
      getTemplates(search, activeSort, sortOrder, page)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}